import { z } from 'zod';

import { MatchingRecord } from '@eluve/utils';

import { MedicalCodeTypesEnum } from './types';

export const MedicalCodeTypesLookup = {
  CPT: 'CPT',
  ICD_10: 'ICD_10',
  SNOMED: 'SNOMED',
  HCPCS: 'HCPCS',
  MBS: 'MBS',
} as const satisfies MatchingRecord<MedicalCodeTypesEnum>;

export const DiagnosticMedicalCodeTypes: string[] = [
  MedicalCodeTypesLookup.ICD_10,
  MedicalCodeTypesLookup.SNOMED,
];

export const ProceduralMedicalCodeTypes: string[] = [
  MedicalCodeTypesLookup.CPT,
  MedicalCodeTypesLookup.HCPCS,
  // MBS items are procedural (attendance/service items with fees). Tenants
  // without MBS codes are unaffected — this is an inclusion filter, not a
  // per-tenant enablement.
  MedicalCodeTypesLookup.MBS,
];

export const AllMedicalCodeTypes: MedicalCodeTypesEnum[] = [
  ...(DiagnosticMedicalCodeTypes as MedicalCodeTypesEnum[]),
  ...(ProceduralMedicalCodeTypes as MedicalCodeTypesEnum[]),
];

export const MedicalCodeTypesSchema = z.nativeEnum(MedicalCodeTypesLookup);
